import { render } from "./show-category-item.vue?vue&type=template&id=62d2aab2&scoped=true&ts=true"
import script from "./show-category-item.vue?vue&type=script&lang=ts"
export * from "./show-category-item.vue?vue&type=script&lang=ts"

import "./show-category-item.vue?vue&type=style&index=0&id=62d2aab2&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-62d2aab2"]])

export default __exports__